export default __webpack_public_path__ + "static/media/LENS_CULINARIS_DEFAULT_fragment_7.a80caf37.jpg";